import apiClient from '../../services/ApiService'

const state = {
  configuraciones: {},
  itemsPerPage: 20 // Valor por defecto
}

const getters = {
  configuraciones: state => state.configuraciones,
  itemsPerPage: state => state.itemsPerPage
}

const actions = {
  async fetchConfiguraciones({ commit }) {
    try {
      const response = await apiClient.get('/configuraciones')
      commit('setConfiguraciones', response.data.data || {})
      
      // Buscar la configuración de elementos por página
      const itemsPerPage = response.data.data.find(config => config.CLAVE === 'ITEMS_PER_PAGE')
      if (itemsPerPage) {
        commit('setItemsPerPage', parseInt(itemsPerPage.VALOR) || 20)
      }
      
      return response
    } catch (error) {
      console.error('Error fetching configuraciones:', error)
      throw error
    }
  },
  
  async createConfiguracion({ commit, dispatch }, configuracion) {
    try {
      const response = await apiClient.post('/configuraciones', configuracion)
      
      // Recargar todas las configuraciones para mantener la coherencia
      await dispatch('fetchConfiguraciones')
      
      return response
    } catch (error) {
      throw error
    }
  },
  
  async updateConfiguracion({ commit, dispatch }, { id, configuracion }) {
    try {
      const response = await apiClient.put(`/configuraciones/${id}`, configuracion)
      
      // Recargar todas las configuraciones para mantener la coherencia
      await dispatch('fetchConfiguraciones')
      
      return response
    } catch (error) {
      throw error
    }
  }
}

const mutations = {
  setConfiguraciones(state, configuraciones) {
    state.configuraciones = configuraciones
  },
  setItemsPerPage(state, itemsPerPage) {
    state.itemsPerPage = itemsPerPage
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}